import { AddressType, TitleId } from '@domgen/dgx-fe-common';
import { PersonalDetailsFormValue } from '../../models/personal-details/personal-details-form-value.type';

export const mockPersonalDetailsFormValue: PersonalDetailsFormValue = {
  address: {
    id: 'GB|RM|B|445899',
    addressLine1: '123 Fairwater House',
    addressLine2: '3 Bonnet Street',
    addressLine3: 'London',
    addressLine4: '',
    postalCode: 'E16 2SZ',
    countryCode: 'GBR',
    countryIso2: 'GB',
    countryIso3: 'GBR',
    countryIsoNumber: 826,
    countryName: 'Great Britain',
    type: AddressType.Residential,
    isOverrideAddress: true,
  },
  emailAddress: 'bob@ross.com',
  firstName: 'Bob',
  lastName: 'Ross',
  telephoneNumber: '0123456789',
  titleId: TitleId.Mr,
};
